import * as api from "..";
import * as endpoints from "../endpoints";
import { ReturnAddress } from "types";

export const loadDestinationsForRegion = async (region: string) => {
  const { data } = await api.post<ReturnAddress[]>(endpoints.destination, {
    action: "get",
    brand_id: 25,
    owner_company: 180480,
    state: region,
  });

  return data;
};
